import { clearCatalogToken } from '_services/Api/PatternLibrary/catalogToken';
import Cookies from 'js-cookie';
import LocalStorage from '../LocalStorage';

const key = 'is_logged_in';

export const isUserLoggedIn = (): boolean => {
    // Primary: app-local flag
    if (LocalStorage.get(key)) return true;

    // Fallback for iOS PWA: recover from persisted session cookie
    // LocalStorage can be evicted when the app is killed; the cookie remains.
    const sessionCookie = Cookies.get('knitnote_session');
    if (sessionCookie) {
        // Self-heal the local flag to prevent redirect loops
        LocalStorage.set(key, 'true');
        return true;
    }

    return false;
};

export const setIsLoggedIn = (): void => {
    LocalStorage.set(key, 'true');
};

export const clearCookiesAndSetLoggedOut = (): void => {
    Cookies.remove('knitnote_session');
    Cookies.remove('XSRF-TOKEN');
    LocalStorage.remove(key);
    // The catalogue token outlives the session that minted it (up to an hour),
    // so signing in as someone else would otherwise reuse it.
    clearCatalogToken();
};
